import { isWx } from './ua'
import {
    checkStorage
} from 'utils/util'
import store from '@/store/index'
const LOCAL_USER_INFO = 'LOCAL_USER_INFO'
const LOCAL_WX_USER_INFO = 'LOCAL_WX_USER_INFO'
// 初始化时候从localStorage获取登录信息
export const getLoginInfo = () => {
    if (checkStorage().valid) {
        try {
            if (isWx()) {
                return JSON.parse(localStorage.getItem(LOCAL_WX_USER_INFO)) || ''
            } else {
                return JSON.parse(localStorage.getItem(LOCAL_USER_INFO)) || ''
            }
        } catch (err) {
            return ''
        }
    } else {
        if (isWx()) {
            return JSON.parse(sessionStorage.getItem(LOCAL_WX_USER_INFO)) || ''
        } else {
            return JSON.parse(sessionStorage.getItem(LOCAL_USER_INFO))  || ''
        }
        // return JSON.parse(sessionStorage.getItem(LOCAL_USER_INFO)) || ''
    }
}

export const setLoginInfo = info => {
    if (checkStorage().valid) {
        if (isWx()) {
            localStorage.setItem(LOCAL_WX_USER_INFO, JSON.stringify(info || ''))
            store.dispatch('visitLog', '')
        } else {
            localStorage.setItem(LOCAL_USER_INFO, JSON.stringify(info || ''))
            store.dispatch('visitLog', '')
        }
    } else {
        if (isWx()) {
            sessionStorage.setItem(LOCAL_WX_USER_INFO, JSON.stringify(info))
            store.dispatch('visitLog', '')
            // return JSON.parse(sessionStorage.getItem(LOCAL_WX_USER_INFO) || '')
        } else {
            sessionStorage.setItem(LOCAL_USER_INFO, JSON.stringify(info))
            store.dispatch('visitLog', '')
            // return JSON.parse(sessionStorage.getItem(LOCAL_USER_INFO) || '')
        }
        // window[LOCAL_USER_INFO] = info
        // sessionStorage.setItem(LOCAL_USER_INFO, JSON.stringify(info))
    }
}

export const deleteLoginInfo = () => {
    if (checkStorage().valid) {
        if (isWx()) {
            localStorage.removeItem(LOCAL_WX_USER_INFO)
        } else {
            localStorage.removeItem(LOCAL_USER_INFO)
        }
    } else {
        if (isWx()) {
            sessionStorage.removeItem(LOCAL_WX_USER_INFO)
        } else {
            sessionStorage.removeItem(LOCAL_USER_INFO)
        }
    }
}

const resolveAppInfo = cb => {
    const localInfo = getLoginInfo()
    cb(localInfo)
}

export default resolveAppInfo
